/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import {
  FaInternetExplorer,
  FaChalkboardTeacher,
  FaCameraRetro,
  FaPinterest,
  FaVideo,
  FaTabletAlt,
  FaRegNewspaper,
  FaSass,
  FaReact,
  FaGitAlt,
  FaAws,
  FaJenkins,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiGatsby,
  SiJavascript,
  SiGithub,
  SiGooglecloud,
  SiKubernetes,
  SiDocker,
  SiHelm,
  SiTerraform,
  SiBitbucket,
  SiAzuredevops,
  SiGitlab,
} from "react-icons/si";
import { VscAzure, VscTerminalCmd } from 'react-icons/vsc';
import { MdDesignServices } from "react-icons/md";


// export declare const VscAzure: IconType;
// export declare const DiGoogleCloudPlatform: IconType;
// SiGooglecloud
// export declare const FaAws: IconType;
// export declare const FaJenkins: IconType;
// export declare const SiKubernetes: IconType;
// export declare const SiAzuredevops: IconType;
// export declare const SiTerraform: IconType;
// export declare const SiHelm: IconType;
// export declare const SiBitbucket: IconType;
// export declare const SiGitlab: IconType;
// export declare const SiDocker: IconType;

export const servicesData = [

  {
    id: 1,
    title: "AWS",
    icon: <FaAws/>,
  },
  {
    id: 2,
    title: "Microsoft Azure",
    icon: <VscAzure/>,
  },
  {
    id: 3,
    title: 'Google Cloud Platform',
    icon: <SiGooglecloud/>
  },
  {
    id: 4,
    title: "GitHub",
    icon: <SiGithub />,
  },
  {
    id: 5,
    title: "Git",
    icon: <FaGitAlt />,
  },
  {
    id: 6,
    title: "Jenkins",
    icon: <FaJenkins />,
  },
  {
    id: 7,
    title: "Kubernetes",
    icon: <SiKubernetes />,
  },
  {
    id: 8,
    title: "Docker",
    icon: <SiDocker />,
  },
  {
    id: 9,
    title: "Helm",
    icon: <SiHelm />,
  },
  {
    id: 10,
    title: "Terraform",
    icon: <SiTerraform />,
  },
  {
    id: 11,
    title: "Gitlab",
    icon: <SiGitlab />,

  },
  {
    id: 12,
    title: "Bitbucket",
    icon: <SiBitbucket />,

  },
  {
    id: 13,
    title: "Azure DevOps",
    icon: <SiAzuredevops />,

  },
];

  // {
  //     id: 4,
  //     title: 'Internet Research',
  //     icon: <FaInternetExplorer />
  // },
  // {
  //     id: 5,
  //     title: 'Tutoring',
  //     icon: <FaChalkboardTeacher />
  // },

  // {
  //   id: 6,
  //   title: "Designing",
  //   icon: <MdDesignServices />,
  // },
  // {
  //     id: 8,
  //     title: 'Pinterest Virtual Assistant',
  //     icon: <FaPinterest />
  // },
  // {
  //   id: 9,
  //   title: "Video Editing",
  //   icon: <FaVideo />,
  // },
  // {
  //     id: 10,
  //     title: 'Data Entry',
  //     icon: <BsClipboardData />
  // },
  // {
  //     id: 12,
  //     title: 'Audio Transcription',
  //     icon: <AiFillAudio />
  // },
  // {
  //   id: 13,
  //   title: "Blog Posting",
  //   icon: <FaRegNewspaper />,
  // },
  // {
  //   id: 14,
  //   title: "Sass",
  //   icon: <FaSass />,
  // },
  // {
  //   id: 15,
  //   title: "React JS",
  //   icon: <FaReact />,
  // },
  // {
  //   id: 16,
  //   title: "TailwindCSS",
  //   icon: <SiTailwindcss />,
  // },
  // {
  //   id: 17,
  //   title: "Next JS",
  //   icon: (
  //     <svg
  //       width="32px"
  //       height="32px"
  //       viewBox="0 0 32 32"
  //       fill="white"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path d="M23.749 30.005c-0.119 0.063-0.109 0.083 0.005 0.025 0.037-0.015 0.068-0.036 0.095-0.061 0-0.021 0-0.021-0.1 0.036zM23.989 29.875c-0.057 0.047-0.057 0.047 0.011 0.016 0.036-0.021 0.068-0.041 0.068-0.047 0-0.027-0.016-0.021-0.079 0.031zM24.145 29.781c-0.057 0.047-0.057 0.047 0.011 0.016 0.037-0.021 0.068-0.043 0.068-0.048 0-0.025-0.016-0.020-0.079 0.032zM24.303 29.688c-0.057 0.047-0.057 0.047 0.009 0.015 0.037-0.020 0.068-0.041 0.068-0.047 0-0.025-0.016-0.020-0.077 0.032zM24.516 29.547c-0.109 0.073-0.147 0.12-0.047 0.068 0.067-0.041 0.181-0.131 0.161-0.131-0.043 0.016-0.079 0.043-0.115 0.063zM14.953 0.011c-0.073 0.005-0.292 0.025-0.484 0.041-4.548 0.412-8.803 2.86-11.5 6.631-1.491 2.067-2.459 4.468-2.824 6.989-0.129 0.88-0.145 1.14-0.145 2.333 0 1.192 0.016 1.448 0.145 2.328 0.871 6.011 5.147 11.057 10.943 12.927 1.043 0.333 2.136 0.563 3.381 0.704 0.484 0.052 2.577 0.052 3.061 0 2.152-0.24 3.969-0.771 5.767-1.688 0.276-0.14 0.328-0.177 0.291-0.208-0.88-1.161-1.744-2.323-2.609-3.495l-2.557-3.453-3.203-4.745c-1.068-1.588-2.14-3.172-3.229-4.744-0.011 0-0.025 2.109-0.031 4.681-0.011 4.505-0.011 4.688-0.068 4.792-0.057 0.125-0.151 0.229-0.276 0.287-0.099 0.047-0.188 0.057-0.661 0.057h-0.541l-0.141-0.088c-0.088-0.057-0.161-0.136-0.208-0.229l-0.068-0.141 0.005-6.271 0.011-6.271 0.099-0.125c0.063-0.077 0.141-0.14 0.229-0.187 0.131-0.063 0.183-0.073 0.724-0.073 0.635 0 0.74 0.025 0.907 0.208 1.296 1.932 2.588 3.869 3.859 5.812 2.079 3.152 4.917 7.453 6.312 9.563l2.537 3.839 0.125-0.083c1.219-0.813 2.328-1.781 3.285-2.885 2.016-2.308 3.324-5.147 3.767-8.177 0.129-0.88 0.145-1.141 0.145-2.333 0-1.193-0.016-1.448-0.145-2.328-0.871-6.011-5.147-11.057-10.943-12.928-1.084-0.343-2.199-0.577-3.328-0.697-0.303-0.031-2.371-0.068-2.631-0.041zM21.5 9.688c0.151 0.072 0.265 0.208 0.317 0.364 0.027 0.084 0.032 1.823 0.027 5.74l-0.011 5.624-0.989-1.52-0.995-1.521v-4.083c0-2.647 0.011-4.131 0.025-4.204 0.047-0.167 0.161-0.307 0.313-0.395 0.124-0.063 0.172-0.068 0.667-0.068 0.463 0 0.541 0.005 0.645 0.063z" />
  //     </svg>
  //   ),
  // },
  // {
  //   id: 18,
  //   title: "Gatsby JS",
  //   icon: <SiGatsby />,
  // },
  // {
  //   id: 19,
  //   title: "Vanilla JavaScript",
  //   icon: <SiJavascript />,
  // },


// Uncomment your required service.
// You can also add on your own 😉.
